import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Input } from 'antd';

import s from './styles.less';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  type: PropTypes.string,
  label: PropTypes.any,
};
const defaultProps = {
  type: 'text',
};

const FilterInput = ({ label, name, ...input }) => (
  <Fragment>
    <label className={s.label} htmlFor={name}>
      {label || name}
    </label>
    <Input name={name} id={name} {...input} />
  </Fragment>
);

FilterInput.propTypes = propTypes;
FilterInput.defaultProps = defaultProps;

export default FilterInput;
